<template>
    <div class="caseApply">
        <div class="caseApplyHead">
            <!-- <div class="caseApplyTitle">病案复印助手</div> -->
            <van-steps :active="active" active-color="#fff">
                <van-step>复印申请</van-step>
                <van-step>身份认证</van-step>
                <van-step>复印信息</van-step>
                <van-step>支付结算</van-step>
            </van-steps>

        </div>

        <ul>
            <!-- 儿童医院 住院号 限制5位 -->
            <li class="caseApplyMessage" v-if="this.casePathMessage.caseList.caseId != '6' && this.hospitalObj.orgUUId == '053eb9c4640911e9ac3f00163e0ee78c'"><span>{{this.hospitalCardLable}}</span><input type="text" maxlength='5' v-model="ruleForm.hospitalCard"
                                                                     :placeholder="this.hospitalCardHolder"></li>
            <li class="caseApplyMessage" v-if="this.casePathMessage.caseList.caseId == '6' || this.hospitalObj.orgUUId != '053eb9c4640911e9ac3f00163e0ee78c'"><span>{{this.hospitalCardLable}}</span><input type="text" v-model="ruleForm.hospitalCard"
                                                                     :placeholder="this.hospitalCardHolder"></li>
            <!-- 屏蔽入院日期 2022-09-24  -->
            <!-- <li class="caseApplyMessage" @click="chooseStartDate" v-if="this.casePathMessage.caseList.caseId != '6'"><span>入院日期</span><input type="text"
                                                                                          v-model="ruleForm.liStartDate"
                                                                                          placeholder="请输入院日期"  readonly></li> -->
            <!-- <li v-if="this.casePathMessage.caseList.caseId != '6'">
                <van-datetime-picker
                        type="date"
                        :min-date="date2015"
                        :max-date="currDate"
                        v-model="startDate"
                        :visible-item-count="3"
                        v-show="startDateFlag"
                        @confirm="getStartDate"
                        @cancel="cancelStartDate"
                />
            </li> -->
            <li class="caseApplyMessage" :class="borderTopFlag?'borderTop':''" @click="chooseEndDate">
                <span>{{this.endDateLable}}</span><input type="text" v-model="ruleForm.liEndDate" :placeholder="this.endDateHolder"  readonly></li>
            <li>
                <van-datetime-picker
                        type="date"
                        :min-date="date2015"
                        :max-date="currDate"
                        v-model="endDate"
                        :visible-item-count="3"
                        v-show="endDateFlag"
                        @confirm="getEndDate"
                        @cancle="cancelEndDate"
                />
            </li>
        </ul>
        <!-- 屏蔽入院日期 2022-09-24 -->
        <!-- <div class="caseApplyBg" v-show="startDateFlag" @click="cancelStartDate"></div> -->
        <div class="caseApplyBg" v-show="endDateFlag" @click="cancelEndDate"></div>
        <div class="caseApplyTypeNav" @click="showAllCaseType">
            <span class="IDCardTitle">复印类型选择</span>
            <span class="chooseHospital">请选择复印类型<van-icon name="arrow"/></span>
        </div>
        <van-picker
                show-toolbar
                title=""
                :columns="copyTypeList"
                value-key="serviceName"
                @cancel="onCancel"
                @confirm="onConfirm"
                :visible-item-count="3"
                v-show="caseApplyTypeFlag"
        />
        <div class="caseApplyBg" v-show="caseApplyTypeFlag" @click="onCancel"></div>
        <div class="caseAllContent">
            <div class="caseOneContent" v-for="(item,index) in ruleForm.casePathList" :key="item.name">
                <div class="caseOneContentTop"><span>{{item.serviceName}}</span>
                    <van-icon name="delete" @click="casePathDel(item,index)"/>
                </div>
                <div>
                    <van-stepper v-model="item.value" :integer="true" :disable-input="true"/>
                    <van-icon name="arrow" style="margin-top:0.08rem;" @click="showDialog"/>
                </div>
            </div>
            <!-- <div class="caseOneContent">
                <div class="caseOneContentTop"><span>全部复印</span><van-icon name="delete" /></div>
                <div><van-stepper v-model="value" /><van-icon name="arrow" style="margin-top:0.08rem;" /></div>
            </div> -->
        </div>
        <div class="readAndAgree">
            <van-checkbox v-model="ruleForm.checked" checked-color="#1C84F2"></van-checkbox>
            <span @click="radioChecked">已阅读并同意《复印条款（免责声明）》</span>
        </div>
        <div class="caseApplyFooter">
            <input type="button" value="保存" :disabled="btnFlag" :class="btnFlag?'':'btnactive'" @click="createOrder">
        </div>
        <van-dialog id="showDialog"
                    v-model="show"
                    title="复印信息"
                    :show-cancel-button="false"
                    confirm-button-text="我知道了"
        >
            <van-field
                    label="住院号（急诊号）"
                    v-model="ruleForm.hospitalCard"
            />
            <!-- 屏蔽入院日期 2022-09-24 -->
            <!-- <van-field
                    label="入院时间"
                    v-model="ruleForm.liStartDate"
            /> -->
            <van-field
                    label="出院日期"
                    v-model="ruleForm.liEndDate"
            />
        </van-dialog>
        <div class="caseApplyBg" v-show="loadingFlag"></div>
        <van-loading color="white" v-show="loadingFlag"/>
    </div>
</template>
<script>
  import {Toast} from 'vant'
  import ApiSetting from '@/assets/js/api'

  export default {
    data () {
      return {
        active: 2,
        ruleForm: {
          hospitalCard: '',
          // liStartDate: '', 屏蔽入院日期 2022-09-24
          liEndDate: '',
          casePathList: [],
          checked: false,
          orderId: '',
          yffy: '', //预付费用
          yjfy: '', //邮寄费用
          fwfy: '',  //服务费用
          totalMoney: '', //总费用
          statusId: '',
          created_time: ''
        },
        loadingFlag: false,
        btnFlag: true,
        // startDate: new Date(), 屏蔽入院日期 2022-09-24
        endDate: new Date(),
        currDate: new Date(),
        date2015: new Date(2015, 0, 1),
        // startDateFlag: false, 屏蔽入院日期 2022-09-24
        endDateFlag: false,
        borderTopFlag: false,
        copyTypeList: [],
        caseApplyTypeFlag: false,
        show: false,
        hospitalObj: '',
        casePathMessage: '',
        casePersonMessage: '',
        hospitalCardLable:'住院号（急诊号）',
        endDateLable:'出院时间',
        hospitalCardHolder:'请输入住院号（急诊号）',
        endDateHolder:'请输入出院时间'
      }
    },
    watch: {
      'ruleForm': {
        handler (newValue, oldValue) {
          if (newValue.hospitalCard == ''
            // || (newValue.liStartDate == '' && '6' != this.casePathMessage.caseList.caseId)  屏蔽入院日期 2022-09-24
            || newValue.liEndDate == ''
            || newValue.casePathList.length <= 0
            || newValue.checked == false) {
            this.btnFlag = true
          } else {
            this.btnFlag = false
          }
          // 京都儿童医院只允许数字，其他数字和字母
          if (this.hospitalObj.orgUUId == '053eb9c4640911e9ac3f00163e0ee78c') {
            newValue.hospitalCard = newValue.hospitalCard.replace(/^(0+)|[^\d]+/g,'')
          } else {
            newValue.hospitalCard = newValue.hospitalCard.replace(/[\W]/g,'')
          }
        },
        deep: true
      }
    },
    created () {
      this.hospitalObj = JSON.parse(sessionStorage.getItem('obj'))
      this.casePathMessage = JSON.parse(sessionStorage.getItem('casePathMessage'))
      this.casePersonMessage = JSON.parse(sessionStorage.getItem('casePersonMessage'))
      if ('6' == this.casePathMessage.caseList.caseId) {
          this.hospitalCardLable = "就诊卡号";
          this.endDateLable = "就诊日期";
          this.hospitalCardHolder = "请输入就诊卡号";
          this.endDateHolder = "请输入就诊日期";
      }
      // this.ruleForm.liStartDate=this.changeDate(this.startDate)
      // this.ruleForm.liEndDate=this.changeDate(this.endDate)
    },
    methods: {
      radioChecked () {
        this.ruleForm.checked = !this.ruleForm.checked
      },
      createOrder () {
        // 屏蔽入院日期 2022-09-24
        // if (null == this.ruleForm.liStartDate || undefined == this.ruleForm.liStartDate) {
        //   Toast.fail('请填写入院日期！')
        //   return
        // }
        if (null == this.ruleForm.liEndDate || undefined == this.ruleForm.liEndDate) {
          Toast.fail('请填写出院日期！')
          return
        }
        // 京都儿童医院限制就诊卡和住院号对应的长度
        if (this.hospitalObj.orgUUId == '053eb9c4640911e9ac3f00163e0ee78c') {
          let hospitalCardLength = this.ruleForm.hospitalCard.length
          if ('6' == this.casePathMessage.caseList.caseId && hospitalCardLength != 14) {
            Toast.fail('就诊卡号必须是14位数字！')
            return
          }
          if ('6' != this.casePathMessage.caseList.caseId && hospitalCardLength != 5) {
            Toast.fail('住院号必须是5位数字！')
            return
          }
        }
        this.loadingFlag = true
        sessionStorage.setItem('casePathList', JSON.stringify(this.ruleForm))
        //修改入院出院时间start
        // 屏蔽入院日期 2022-09-24
        // var newDate = new Date();
        // newDate.setHours(0);
        // newDate.setMinutes(0);
        // newDate.setSeconds(0);
        var newDate1 = new Date();
        newDate1.setHours(0);
        newDate1.setMinutes(0);
        newDate1.setSeconds(0);
        // 屏蔽入院日期 2022-09-24
        // var startDate =this.ruleForm.liStartDate.split("-"); 
        // console.info("startDate:" + startDate);
        // newDate.setFullYear(Number(startDate[0]));
        // newDate.setMonth(Number(startDate[1])-1);
        // newDate.setDate(Number(startDate[2]));
        // var inpTimeDate = newDate;
        var endDate =this.ruleForm.liEndDate.split("-");
        console.info("endDate:" + endDate);
        newDate1.setFullYear(Number(endDate[0]));
        newDate1.setMonth(Number(endDate[1])-1);
        newDate1.setDate(Number(endDate[2]));
        var disTimeDate = newDate1;
        //修改入院出院时间end
        // 屏蔽入院日期 2022-09-24
        // console.info('inpTimeDate:' + inpTimeDate)
        console.info('disTimeDate:' + disTimeDate)
        var param = {
          //customerId:'',
          //principalId:'',
          //deptId:'',
          'orgUuid': this.hospitalObj.orgUUId,
          'caseType': this.casePathMessage.caseList.caseId,
          'srvType': this.casePathMessage.serviceList.serviceId,
          'disFlag': '1',
          // 'inpTime': inpTimeDate, 屏蔽入院日期 2022-09-24
          'disTime': disTimeDate,
          'copyType': this.ruleForm.casePathList[0].serviceId,

          'amount': this.ruleForm.casePathList[0].value,
          'identityType': this.casePersonMessage.identityType,
          'customerName': this.casePersonMessage.patientName,
          'idCardNo': this.casePersonMessage.IDCard,
          'cellphone': this.casePersonMessage.phoneNum,
          'viledateCode': this.casePersonMessage.codeNum,
          'hospitalNo': this.ruleForm.hospitalCard,
          'address.name': this.casePathMessage.Addressee,
          'address.tel': this.casePathMessage.phoneNum,
          'address.stateId': this.casePathMessage.stateId,
          'address.cityId': this.casePathMessage.cityId,
          'address.districtId': this.casePathMessage.districtId,
          'address.stateName': this.casePathMessage.stateName,
          'address.cityName': this.casePathMessage.cityName,
          'address.districtName': this.casePathMessage.districtName,
          'address.subdistrict': this.casePathMessage.addressDescName,
          'idCardType': this.casePersonMessage.idCardType,
          'imgUrlList': this.casePersonMessage.fileUrlList
        }
        if ('6' == this.casePathMessage.caseList.caseId) {
            param.inpTime = param.disTime; // 门诊病案，入院日期等于就诊日期
        }
        this.postRequest(ApiSetting.createOrder, param).then((res) => {
          if (res.data.responseCode == '200') {
            this.ruleForm.created_time = res.data.data.created_time
            this.ruleForm.orderId = res.data.data.orderId
            this.ruleForm.yffy = res.data.data.yffy
            this.ruleForm.yjfy = res.data.data.yjfy
            this.ruleForm.fwfy = res.data.data.fwfy
            this.ruleForm.totalMoney = res.data.data.totalMoney
            this.ruleForm.statusId = res.data.data.statusId
            this.loadingFlag = false
            Toast.success('保存成功')
            sessionStorage.setItem('casePathList', JSON.stringify(this.ruleForm))
            if (this.hospitalObj.payType == '12') { // 预付费模式
              setTimeout(() => {
                this.$router.push({path: '/caseApplyFourth'})
              }, 2000)
            } else {
              setTimeout(() => {
                this.$router.push({path: '/myOrder'})
              }, 2000)
            }

          } else if (res.data.responseCode == '0') {
            Toast.fail('保存失败，' + res.data.msg)
            this.loadingFlag = false
          } else {
            Toast.fail('保存失败！')
            this.loadingFlag = false
          }
        })
      },
      showDialog () {
        this.show = true
      },
      casePathDel (item, index) {
        this.ruleForm.casePathList.splice(index, 1)
      },
      showAllCaseType () {
        this.caseApplyTypeFlag = true
      },
      onConfirm (value, index) {
        var list = [{serviceName: value.serviceName, serviceId: value.serviceId, value: '1'}]
        this.ruleForm.casePathList = list
        console.log(this.ruleForm.casePathList)
        this.caseApplyTypeFlag = false
      },
      onCancel () {
        this.caseApplyTypeFlag = false
      },
      // 屏蔽入院日期 2022-09-24
      // cancelStartDate () {
      //   this.startDateFlag = false
      // },
      cancelEndDate () {
        this.endDateFlag = false
      },
      //最新
      // 屏蔽入院日期 2022-09-24
      // getStartDate (value) {
      //   this.ruleForm.liStartDate = this.changeDate(value)
      //   // this.ruleForm.liEndDate = ''
      //   this.startDateFlag = false
      //   if (this.ruleForm.liStartDate == this.ruleForm.liEndDate) {
      //     Toast.fail('注意：入院日期和出院日期是同一天了！')
      //   }
      // },
      //最新
      getEndDate (value) {
        this.ruleForm.liEndDate = this.changeDate(value)
        this.endDateFlag = false
        // 屏蔽入院日期 2022-09-24
        // if (this.ruleForm.liStartDate == this.ruleForm.liEndDate) {
        //   Toast.fail('注意：入院日期和出院日期是同一天了！')
        // }
      },
      //最新
      changeDate (date) {
        this.endDate = date
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        if (month < 10) {
          month = '0' + month
        }
        if (day < 10) {
          day = '0' + day
        }

        return year + '-' + month + '-' + day
      },
      // 屏蔽入院日期 2022-09-24
      // chooseStartDate () {
      //   this.startDateFlag = !this.startDateFlag
      //   this.borderTopFlag = !this.borderTopFlag
      // },
      chooseEndDate () {
        this.endDateFlag = !this.endDateFlag
        this.borderTopFlag = !this.borderTopFlag
      }
    },
    mounted () {
      var param = {
          orgUUid: this.hospitalObj.orgUUId,
          serviceType: 3,
          caseType: this.casePathMessage.caseList.caseId,
      }
      this.postRequest(ApiSetting.getOrgServiceDic, param).then((res) => {
        if (res.data.responseCode == '200') {
          this.copyTypeList = res.data.data
        }
      })
    }
  }
</script>
<style lang="less" scoped>
    .van-picker {
        position: fixed;
        width: 100%;
        z-index: 99;
        bottom: 0;
        left: 0;
    }

    // .van-loading{
    //     width: 1rem;
    //     height: 1rem;
    //     position: fixed;
    //     left: 50%;
    //     top: 50%;
    //     margin-left: -0.5rem;
    //     margin-top: -0.5rem;
    //     z-index: 99;
    // }
    .caseApply .caseApplyMessage input {
        left: 2.4rem;
    }

    .caseApplyHead {
        border-bottom: 1px solid #e4e4e4;
    }

    .borderTop {
        border-top: 1px solid #e4e4e4;
    }

    #showDialog {
        /deep/
        .van-cell__title {
            max-width: 100px !important;
        }

        /deep/
        .van-dialog__confirm {
            color: #1C84F2 !important;
        }
    }

    .readAndAgree {
        font-size: 0.24rem;
        color: #999999;
        height: 0.6rem;
        line-height: 0.6rem;
        .van-checkbox {
            float: left;
            margin-left: 5%;
            margin-right: 0.1rem;
            /deep/
            .van-checkbox__icon--checked .van-icon {
                border-color: #1C84F2 !important;
                background-color: #1C84F2 !important;
            }
            /deep/
            .van-checkbox__icon .van-icon {
                border: 1px solid #999999 !important;
                width: 0.32rem;
                height: 0.32rem;
                margin: 0rem;
                line-height: 0.32rem;
                appearance: none;
                -webkit-appearance: none;
            }
        }
        span {
            display: inline-block;
            float: left;
        }
    }

    .caseApplyTypeNav {
        border-bottom: 1px solid #e4e4e4;
        .chooseHospital {
            float: right;
            margin-right: 0.2rem;
            font-size: 0.28rem;
            color: #333333;
        }
        .IDCardTitle {
            display: inline-block;
            color: #333333;
        }
        .van-icon {
            position: relative;
            top: 0.04rem;
        }

    }

    /deep/
    .van-picker__cancel {
        color: #1C84F2 !important;
    }

    /deep/
    .van-picker__confirm {
        color: #1C84F2 !important;
    }

    .caseAllContent {
        background: #ffffff;
        font-size: 0.28rem;
        color: #333333;
        padding-top: 0.2rem;
        .caseOneContent:first-child {
            margin-top: 0rem;
        }
        .caseOneContent {
            width: 90%;
            margin-left: 5%;
            border: 1px solid #e4e4e4;
            overflow: hidden;
            margin-top: 0.2rem;
            .van-stepper {
                width: 3rem;
                margin: 0 0 0.1rem 0.2rem;
                float: left;
                /deep/
                .van-stepper__minus {
                    height: 0.4rem !important;
                    width: 0.4rem !important;
                }
                /deep/
                .van-stepper__input {
                    height: 0.3rem !important;
                    width: 0.4rem !important;
                    padding-top: 0.04rem !important;
                    color: #1C84F2;
                }
                /deep/
                .van-stepper__plus {
                    height: 0.4rem !important;
                    width: 0.4rem !important;
                }
            }
            .van-icon {
                float: right;
                margin-top: 0.16rem;
                margin-right: 0.2rem;
            }
            .caseOneContentTop {
                height: 0.6rem;
                line-height: 0.6rem;
                margin-left: 0.2rem;
            }

        }
    }


</style>

